export default __webpack_public_path__ + "static/media/openInNew.98a99dd6.svg";